let confettiIntervalId = null;
let confettiLoadPromise = null;

const CONFETTI_Z_INDEX = 20000;

/**
 * canvas-confetti defaults to a blob Worker; app CSP allows script-src 'self' https: only.
 * useWorker: false keeps confetti on the main thread (same visual, CSP-safe).
 */
async function loadCspSafeConfettiFire() {
  if (window.__caseExperienceConfettiFire) return window.__caseExperienceConfettiFire;
  if (!confettiLoadPromise) {
    confettiLoadPromise = import('canvas-confetti')
      .then((module) => {
        const fire = module.default.create(null, { useWorker: false, resize: true });
        window.__caseExperienceConfettiFire = fire;
        return fire;
      })
      .catch((err) => {
        confettiLoadPromise = null;
        throw err;
      });
  }
  return confettiLoadPromise;
}

/** Module-scoped confetti so turbo disconnect on button-action does not cancel it. */
export async function startStudentCaseConfetti() {
  if (confettiIntervalId != null) return;

  try {
    const fire = await loadCspSafeConfettiFire();
    let elapsed = 0;
    confettiIntervalId = window.setInterval(() => {
      [0, 0.5, 1].forEach((x) => {
        fire({
          particleCount: 200,
          spread: 120,
          gravity: 2.5,
          scalar: 1.5,
          startVelocity: 60,
          origin: { x, y: 0 },
          zIndex: CONFETTI_Z_INDEX,
        });
      });
      elapsed += 400;
      if (elapsed >= 2000) {
        stopStudentCaseConfetti();
      }
    }, 400);
  } catch (err) {
    console.error('Case completion confetti failed to load:', err);
  }
}

export function stopStudentCaseConfetti() {
  if (confettiIntervalId == null) return;
  clearInterval(confettiIntervalId);
  confettiIntervalId = null;
}
